import {Component, OnInit} from '@angular/core';
import {AppService} from "../app.service";
import {CiCoInfo, ContentService} from "../content.service";
import {
  ApiConnection, CiCo, Day, PfCiCoResource, PfDayResource, PfItemResource,
} from 'pfapi';

@Component({
    selector: 'app-worker-info',
    templateUrl: './worker-info.component.html',
    styleUrls: ['./worker-info.component.css'],
    standalone: false
})
export class WorkerInfoComponent implements OnInit {
  protected apiConnection: ApiConnection;
  public activeTheme;
  public closeTiemeout;

  constructor(public appService: AppService,
              private contentService: ContentService) {
  }

  ngOnInit() {
    this.activeTheme = this.appService.getColor();
    this.apiConnection = this.appService.getApiConnection();
    this.startTimer();
  }

  public getWorkerInfoWorker() {
    return this.appService.getWorkerInfoWorker();
  }

  public startTimer() {
    this.closeTiemeout = setTimeout(() => {
      this.close();
    }, 6000);
  }

  public toggleCheckin(worker) {
    if (this.appService.getInterfaceAttendanceAllowSimpleCiCo()) {
      this.contentService.cico(worker._apiData.username, !worker._apiData.checkedIn);
    }
    this.close();
  }

  public close() {
    clearTimeout(this.closeTiemeout);
    this.appService.getRouter().navigate(['/content']);
  }
}
